// @flow strict
import React from "react";

type Props = {
  texts: Array<string>,
  renderTag?: (text: string, className?: string) => React$Node,
  className?: string,
  onAnimationEnd?: () => void,
  done?: boolean,
};
type State = {
  trimmed: Array<string>,
  partials: Array<string>,
  iIndex: number,
  iRow: number,
};

const iSpeed = 50; // time delay of print out

export class Typewriter extends React.PureComponent<Props, State> {
  state: State = {
    trimmed: this.props.texts.map((t) => t.split(/\s+/).join(" ")),
    partials: [""],
    iIndex: 0,
    iRow: 0,
  };
  _timeout: TimeoutID;
  _mounted = false;

  componentDidMount() {
    this._mounted = true;
    this._tick();
  }

  componentWillUnmount() {
    this._mounted = false;
    if (this._timeout) {
      clearTimeout(this._timeout);
    }
  }

  _tick = () => {
    const { trimmed, iIndex, iRow } = this.state;
    const row = trimmed[iRow];
    if (!this._mounted) {
      clearTimeout(this._timeout);
    }
    if (iIndex === row.length) {
      if (iRow < trimmed.length - 1) {
        // New parragraph
        this.setState(
          (state) => ({
            partials: [...state.partials, ""],
            iIndex: 0,
            iRow: state.iRow + 1,
          }),
          () => {
            this._timeout = setTimeout(this._tick, 500);
          }
        );
      } else {
        // Finished
        this.setState({ partials: trimmed }, () => {
          if (!this.props.done) {
            this.props.onAnimationEnd && this.props.onAnimationEnd();
          }
        });
      }
    } else {
      // New character
      this.setState(
        (state) => {
          const newPartials = state.partials.slice();
          newPartials[state.iRow] = newPartials[state.iRow] + row[state.iIndex];
          return {
            partials: newPartials,
            iIndex: state.iIndex + 1,
          };
        },
        () => {
          this._timeout = setTimeout(this._tick, iSpeed);
        }
      );
    }
  };

  render(): React$Node {
    const { partials, trimmed } = this.state;
    const { className, done, renderTag } = this.props;
    if (done) {
      return trimmed.map((t) => (renderTag || rendeAsP)(t, className));
    }
    return partials.map((t) => (renderTag || rendeAsP)(t, className));
  }
}
function rendeAsP(text: string, className?: string) {
  return (
    <p className={className} key={text.slice(0, 20)}>
      {text}
    </p>
  );
}
